import { z } from 'zod'

export const ADMINORGADMINDELETE_CONTRACT_VERSION = '1.0.0' as const
export const adminOrgAdminDeleteResponseSchema = z.unknown()
export type AdminOrgAdminDeleteResponse = z.infer<typeof adminOrgAdminDeleteResponseSchema>
